import {DATASET_MIXPANEL} from '../../constants';
import {BaseClient} from '../utils/base-client';
import {processProperties} from './utils';

class PeoplePropertiesClient extends BaseClient {
  buildEndpoint() {
    return `api/2.0/engage/properties`;
  }

  buildQueryParams(options = {}) {
    const {projectId, datasetId, profileTable, dataGroupId, includeCustom, includeDimensionProperties, workspaceId} = {
      datasetId: DATASET_MIXPANEL,
      profileTable: null,
      dataGroupId: null,
      includeCustom: false,
      ...options,
    };
    /* eslint-disable camelcase */
    return {
      project_id: projectId,
      ...(datasetId !== DATASET_MIXPANEL ? {dataset_name: datasetId} : {}),
      // TODO(RNA-183): Remove once profileTypes are removed from Insights.
      ...(profileTable && !dataGroupId ? {where: `properties["Table"] == "${profileTable}"`} : {}),
      ...(dataGroupId ? {data_group_id: dataGroupId} : {}),
      ...(includeCustom ? {include_custom: includeCustom} : {}),
      ...(includeDimensionProperties ? {include_dimension_props: includeDimensionProperties} : {}),
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
    };
    /* eslint-enable camelcase */
  }

  processResponse(response, params) {
    return processProperties(response.results, {dataGroupId: params.dataGroupId});
  }
}

export default new PeoplePropertiesClient();
